module.exports = __webpack_public_path__ + "img/Banner-manage-shop.e533a109.png";